import "../account.scss";
import useAccountDetailsHelper from "./helper";
import BreadcrumbComp from "../../../components/breadcrumb";
const AccountDetails = () => {
  const { breadCrumbItems, accountDetails: AD } = useAccountDetailsHelper();
  return (
    <div className="subscriptionMainWrapper">
      <BreadcrumbComp items={breadCrumbItems} />
      <div className="cardWrapper">
        <div className="cardHeading">
          <h2>Account Details</h2>
        </div>
        <div className="subscriptionDetailsWrapper">
          <div className="detailWrapper">
            <h4 className="key">Account Type</h4>
            <span className="value">{AD?.accountType || "-"}</span>
          </div>

          <div className="detailWrapper">
            <h4 className="key">Bank Name</h4>
            <span className="value">{AD?.bankName || "-"}</span>
          </div>

          <div className="detailWrapper">
            <h4 className="key">Bank Account Name</h4>
            <span className="value">{AD?.name || "-"}</span>
          </div>

          <div className="detailWrapper">
            <h4 className="key">Routing Number</h4>
            <span className="value">{AD?.routing || "-"}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountDetails;
